import axiosInstance from '@/shared/api/axios';
import type {
  ApiLimitConfigGetResponse,
  ApiLimitConfigPutBody,
} from '@/shared/types/api/limit-config';

export const apiLimitConfigGet = async (): Promise<ApiLimitConfigGetResponse> => {
  const { data } = await axiosInstance.get<ApiLimitConfigGetResponse>('/pinfl/limit-config');
  return data;
};

export const apiLimitConfigPut = async (
  body: ApiLimitConfigPutBody,
): Promise<ApiLimitConfigGetResponse> => {
  const { data } = await axiosInstance.put<ApiLimitConfigGetResponse>('/pinfl/limit-config', body);
  return data;
};
